
import Seal from '../../../Elements/Seal.vue'

export default {
  components: { Seal },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      animationCycle: [],
      currentCycle: {},
    }
  },
  mounted() {
    this.buildAnimationSequences()
    this.$nextTick(() => {
      if (this.animationCycle.length > 0) {
        this.initAnim()
        this.startAnimationSequence()
      }
    })
  },
  methods: {
    initAnim() {
      const tl = this.$gsap.timeline({
        delay: 0.5,
      })

      tl.from(this.$refs['header-text'], {
        autoAlpha: 0,
        xPercent: -10,
        duration: 0.6,
        ease: 'back',
      })
      tl.from('.project-info', {
        autoAlpha: 0,
        duration: 0.2,
      })
    },
    startAnimationSequence() {
      const projectTl = this.$gsap.timeline()
      const gsap = this.$gsap
      const imgs = gsap.utils.toArray('.aspot-bg-image')
      const loopAnimation = this.blok.loop_animation
      const animationCycle = this.animationCycle
      const setNextCycle = this.setNextCycle

      const next = 10 // time to change
      const fade = 2 // fade time
      const end = imgs.length

      // initial animation
      gsap.set(imgs[0], { autoAlpha: 1 })

      // main function that handles animation cycle
      function crossfade(start) {
        if (start === end) {
          // inifinite loop
          if (loopAnimation) start = 0
          else return
        }

        // handle bg image fade in/out
        gsap
          .timeline()
          .to(imgs[0], { autoAlpha: 0, duration: fade })
          .fromTo(
            imgs[1],
            { y: -50 },
            { y: 0, autoAlpha: 1, duration: fade },
            0
          )

        // project fade animation
        projectTl
          .to(
            '.project-info',
            {
              autoAlpha: 0,
              duration: 0.2,
              onComplete: () => {
                // fade out -> set next animation cycle -> fade in
                setNextCycle(animationCycle[start])
              },
            },
            0
          )
          .to('.project-info', {
            autoAlpha: 1,
            delay: 0.5,
            duration: 0.5,
          })

        // shift first item to end
        imgs.push(imgs.shift())

        // start endless run
        gsap.delayedCall(next, crossfade, [start + 1])
      }
      // start the crossfade after x seconds
      gsap.delayedCall(next, crossfade, [1])
    },
    setNextCycle(nextCycle) {
      // delay to let animation run
      this.currentCycle = nextCycle
    },
    buildAnimationSequences() {
      const animationObj = [...this.blok.animation_cycle]

      if (animationObj.length < 1) {
        return
      }

      // shuffle
      const shuffledObj = animationObj.sort(() => Math.random() - 0.5)

      // create obj sequence
      const mappedObj = shuffledObj.map((obj, i) => {
        return {
          id: obj._uid,
          image: obj.image,
          project_link: obj.project_link,
          project_location: obj.project_location,
          project_name: obj.project_name,
          project_open_link: obj.project_open_link,
          seal: obj.seal,
        }
      })

      // set data
      this.animationCycle = mappedObj
      this.currentCycle = mappedObj[0]
    },
  },
}
